import { useState } from "react";
import { useTeams } from "../../../../utils/reactQuery/teams";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateTeam, deleteTeam } from "../../../../sevices/apiTeam";
import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton, TextField, Box, Typography } from "@mui/material";
import DeleteIcon from "../../../../styles/svg/adminWorkflowDelete.svg"
import toast from "react-hot-toast";
import FormDialog from "../../../../components/Dialog/FormDialog";

function ManageTeams({ onClose }) {
    const { teams, isLoading: isTeamsLoading } = useTeams();
    const [editingTeamId, setEditingTeamId] = useState(null);
    const [editedTeamName, setEditedTeamName] = useState("");
    const queryClient = useQueryClient();
    const [openDeleteTeamDialog, setOpenDeleteTeamDialog] = useState(false)
    const [selectedTeamId, setSelectedTeamId] = useState("");

    const updateTeamMutation = useMutation({
        mutationFn: updateTeam,
        onSuccess: (response) => {
            toast.success(response?.data?.message)
            queryClient.invalidateQueries({ queryKey: ["teams"] });
            setEditingTeamId(null);
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
            setEditingTeamId(null);
        },
    });

    const deleteTeamMutation = useMutation({
        mutationFn: deleteTeam,
        onSuccess: (response) => {
            toast.success(response?.data?.message)
            queryClient.invalidateQueries({ queryKey: ["teams"] });
            setOpenDeleteTeamDialog(false)
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
            setOpenDeleteTeamDialog(false)
        },
    });

    const handleEditClick = (team) => {
        setEditingTeamId(team.team_id);
        setEditedTeamName(team.team);
    };

    const handleUpdateTeam = (teamId) => {
        if (editedTeamName.trim()) {
            updateTeamMutation.mutate({
                teamId,
                data: { team_name: editedTeamName.trim() },
            });
        }
    };

    const handleKeyPress = (e, teamId) => {
        if (e.key === "Enter") {
            handleUpdateTeam(teamId);
        }
    };

    const handleDeleteClick = (teamId) => {
        setSelectedTeamId(teamId)
        setOpenDeleteTeamDialog(true)
    };

    if (isTeamsLoading) {
        return <div>Loading...</div>;
    }
    const handleCreateTeamClose = () => {
        setOpenDeleteTeamDialog(false)
    }

    const handleSubmit = () => {
        deleteTeamMutation.mutate(selectedTeamId);
    }
    return (
        <Box>
            {openDeleteTeamDialog && (
                <FormDialog
                    open={openDeleteTeamDialog}
                    handleClose={handleCreateTeamClose}
                    title={"Confirmation: Delete Team"}
                    buttonTxt={"Delete"}
                    cancelBtn={true}
                    handleSubmit={handleSubmit}
                    fullWidth={true}>
                    <Typography className="align_text_center mb-2">
                        Are you sure you want to delete this team?
                    </Typography>
                </FormDialog>
            )}
            {teams?.data?.data?.responseData.map((team) => (
                <Box
                    key={team.id}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 1,
                    }}
                >
                    {editingTeamId === team.team_id ? (
                        <TextField
                            value={editedTeamName}
                            onChange={(e) => setEditedTeamName(e.target.value)}
                            onKeyPress={(e) => handleKeyPress(e, team.team_id)}
                            onBlur={() => handleUpdateTeam(team.team_id)}
                            autoFocus
                            size="small"
                            sx={{ flex: 1 }}
                        />
                    ) : (
                        <Typography flex={1}>{team.team}</Typography>
                    )}
                    <IconButton
                        size="small"
                        onClick={() => handleEditClick(team)}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={() => handleDeleteClick(team.team_id)}
                    >
                        <img src={DeleteIcon} />
                    </IconButton>
                </Box>
            ))}
        </Box>
    );
}

export default ManageTeams;
